import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { CheckCircle2, XCircle, Loader2, Info } from 'lucide-react';
import { eventsAPI } from '../api';

const EventVerifyPage = () => {
  const { token } = useParams();
  const [state, setState] = useState({ loading: true, ok: false, error: '', title: '', arrangement_required: false, already: false });

  useEffect(() => {
    let alive = true;
    eventsAPI.verifySubmission(token)
      .then((r) => {
        if (!alive) return;
        setState({
          loading: false,
          ok: true,
          error: '',
          title: r.data.title || '',
          arrangement_required: !!r.data.arrangement_required,
          already: !!r.data.already_verified,
        });
      })
      .catch((e) => {
        if (!alive) return;
        setState({ loading: false, ok: false, error: e.response?.data?.detail || e.message, title: '', arrangement_required: false, already: false });
      });
    return () => { alive = false; };
  }, [token]);

  return (
    <div className="max-w-xl mx-auto px-4 py-16 text-center" data-testid="event-verify-page">
      {state.loading && (
        <div data-testid="verify-loading">
          <Loader2 className="mx-auto text-sky-500 animate-spin" size={40} />
          <p className="text-slate-600 mt-4">Confirming your submission…</p>
        </div>
      )}

      {!state.loading && state.ok && (
        <div data-testid="verify-success">
          <div className="w-16 h-16 mx-auto bg-emerald-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle2 className="text-emerald-600" size={32} />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">{state.already ? 'Already confirmed' : 'Thanks — you\'re confirmed!'}</h1>
          <p className="text-lg text-slate-600 mb-2">{state.title && <>Your event <strong>{state.title}</strong></>} {state.already ? 'was already verified.' : 'is now with our editorial team.'}</p>
          <p className="text-slate-600 mb-6">We aim to review and publish within 24 hours.</p>
          {state.arrangement_required && (
            <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 text-left mb-6" data-testid="verify-arrangement-notice">
              <p className="font-semibold text-amber-900 flex items-center gap-2"><Info size={16} /> Paid event follow-up</p>
              <p className="text-sm text-amber-800 mt-1">
                Because your ticket price is above £5/person, our site owner will be in touch by email in the next 24 hours about the commercial arrangement.
              </p>
            </div>
          )}
          <Link to="/events" className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-semibold">← Back to the events calendar</Link>
        </div>
      )}

      {!state.loading && !state.ok && (
        <div data-testid="verify-failure">
          <div className="w-16 h-16 mx-auto bg-rose-100 rounded-full flex items-center justify-center mb-4">
            <XCircle className="text-rose-600" size={32} />
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Couldn&apos;t confirm your submission</h1>
          <p className="text-slate-600 mb-6">{state.error || 'This link may have expired or been used already.'}</p>
          <Link to="/events/submit" className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-semibold">Submit your event again →</Link>
        </div>
      )}
    </div>
  );
};

export default EventVerifyPage;
